
$(function() {
    const loadCheck = window.setInterval(() => { 
        if (greenForm2Exists()) {
            window.clearTimeout(loadCheck);
            onGreenForm2Loaded();
        }
    }, 500);    
});

const greenForm2Exists = () =>  {
  return $('.leform-inline').length;
};
  

const onGreenForm2Loaded = () => {
  // this is a heavier interval so only execute if the form is loaded
  waitForHardCoverSelect();
};

let waitForHardCoverSelect = () => { 
  let hardcoverCheckInterval = setInterval(function() {
    if ($('.leform-inline select option:contains(Hardcover)').length) {
      clearInterval(hardcoverCheckInterval);
      $('.leform-inline select option:contains(Hardcover)').text(function () {
        return $(this).text().replace('Hardcover', 'Hardcover ' + '+' + varianceprice);
      });
    }
  }, 100);
};